import Box from '@mui/material/Box'
import Carousel from 'react-material-ui-carousel'
import { Typography } from '@mui/material'
import Button from '@mui/material/Button'

import React from 'react'
import MultiLocationAccess from '../../icons/MultiLocationAccess'
import CaseTrackingTimeline from '../../icons/CaseTrackingTimeline'
import VersionControl from '../../icons/VersionControl'

import GlobalStyles from './GlobalStyles'

const HomeCarousel: React.FC<{setLogin:(args:boolean)=>void}> = (props) => {
    const { classes } = GlobalStyles()
    const carouselData = [
        {
            svg: MultiLocationAccess,
            heading: 'Multi Location Access',
            subHeading: 'Collaborate on cases from anywhere with easy data access.',
            link: '',
        },
        {
            svg: CaseTrackingTimeline,
            heading: 'Case Tracking Timeline',
            subHeading: 'Track real-time document changes and updates in matters.',
            link: '',
        },
        {
            svg: VersionControl,
            heading: 'Version Control',
            subHeading: 'Efficiently manage document versions for clarity and accuracy.',
            link: '',
        },
    ]
    return (
        <React.Fragment>
            <Box>
                <Box>
                    <Carousel
                        indicatorIconButtonProps={{
                            style: {
                                color: '#C6DEF8',
                                height: '2px',
                            },
                        }}
                        indicatorContainerProps={{
                            style: {
                                // marginBottom: '1em',
                            },
                        }}
                        activeIndicatorIconButtonProps={{
                            style: {
                                color: '#0077F9',
                            },
                        }}
                        swipe={true}
                        autoPlay={true}
                        navButtonsAlwaysInvisible={true}
                        animation="slide"
                    >
                        {carouselData.map((item, index) => (
                            <Box key={index} className={classes.carouselBox}>
                                <Typography className={classes.heading1}>
                                    {item.heading}
                                </Typography>
                                <Button
                                    onClick={() => {
                                        props.setLogin(true)
                                    }}
                                    className={classes.learnMoreButton}
                                >
                                    Sign In
                                </Button>
                                {' '}
                                <Button
                                    onClick={() => {
                                        window.open("https://www.mattersuite.com/register", '_blank')
                                    }}
                                    className={classes.learnMoreButton}
                                >
                                    Sign Up
                                </Button>
                            </Box>
                        ))}
                    </Carousel>
                </Box>
            </Box>
        </React.Fragment>
    )
}
export default HomeCarousel
